import React from "react";
import { motion } from "framer-motion";
const MySkills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-5 lgl:gap-10"
    >
      {/* design skills */}
      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">Features</p>
          <h2 className="text-3xl lgl:text-4xl font-bold">Design Skills</h2>
        </div>
        <div className="w-full lgl:w-[550px] flex flex-col gap-4">
            {/* Network */}
          <div>
            <p className="text-sm uppercase font-medium">NETWORK DESIGN</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-full h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
          {/* {Photoshop} */}
          <div>
            <p className="text-sm uppercase font-medium">PHOTOSHOP</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-full h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
          {/* Adobe */}
          <div>
            <p className="text-sm uppercase font-medium">ADOBE XD</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[90%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">90%</span>
              </motion.span>
            </span>
          </div>
          {/* {Figma} */}
          <div>
            <p className="text-sm uppercase font-medium">FIGMA</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[80%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">80%</span>
              </motion.span>
            </span>
          </div>
          {/* Adobe Illustration */}
          <div>
            <p className="text-sm uppercase font-medium">ADOBE ILLUSTRATION</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[70%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">70%</span>
              </motion.span>
            </span>
          </div>
        </div>
      </div>

      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">Features</p>
          <h2 className="text-3xl lglt:ext-4xl font-bold">Development Skills</h2>
        </div>
        <div className="w-full lgl:w-[550px] flex flex-col gap-4">
               {/* Network */}
          <div>
            <p className="text-sm uppercase font-medium flex gap-3">NETWORK <p className="text-designColor">( CISCO & HUAWEI )</p></p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-full h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
          {/* React skills */}
          <div>
            <p className="text-sm uppercase font-medium">React & Javascript</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-full h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
           {/* PHP */}
           <div>
            <p className="text-sm uppercase font-medium">PHP & Laravel</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[100%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
          {/* HTML &CSS */}
          <div>
            <p className="text-sm uppercase font-medium">HTML & CSS</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[100%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
           {/* Flutter & Dart*/}
           <div>
            <p className="text-sm uppercase font-medium">FLUTTER & DART</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[100%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
           {/* Java */}
           <div>
            <p className="text-sm uppercase font-medium">JAVA</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[100%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">100%</span>
              </motion.span>
            </span>
          </div>
           {/* C&C++ */}
           <div>
            <p className="text-sm uppercase font-medium">C & C++</p>
            <span className="w-full h-2 bgOpacity inline-flex rounded-md mt-2">
              <motion.span
                initial={{ x: "-100%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="w-[80%] h-full bg-gradient-to-r from-blue-600 vla-pink-500
            to-red-500 rounded-md relative"
              >
                <span className="absolute -top-6 right-0">80%</span>
              </motion.span>
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MySkills;
